// modules
import { addModal } from 'weblite-web-modal-viewer'
import { BookmarkSelectionListModal } from './bookmark-selection-list-modal'

const COMPONENT_ID = 'BookmarkSelectionListModal'

export const showBookmarkSelectionListModal = (
  props: Parameters<typeof BookmarkSelectionListModal>[0],
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: BookmarkSelectionListModal,
  },
}
